import {
    computed, type ComputedRef, type Ref,
} from 'vue';
import { useUserSettingsStore } from '@/stores/userSettingsStore.ts';
import { useDataStore } from '@/stores/powerMarkets/dataStore.ts';
import { WindowType } from '@/types/powerMarkets/balancing/WindowType.ts';
import { PeriodTypeOverrides, PeriodTypeOverridesWithInherited } from '@/types/powerMarkets/balancing/PeriodTypeOverrides.ts';
import { IDatePeriod } from '@/interfaces/powerMarkets/balancing/IDatePeriod.ts';

export function getPeriodToDisplayComputed (
    periodType: Ref<PeriodTypeOverridesWithInherited>,
): ComputedRef<IDatePeriod> {
    const dataStore = useDataStore();

    return computed(() => {
        let periodTypeToUse = periodType.value;
        if (periodType.value === 'inherited') {
            periodTypeToUse = getPeriodPageOverride().value;
        }
        const defaultDatePeriod = { date: new Date(), period: 0 };
        let datePeriodToReturn: IDatePeriod;

        switch (periodTypeToUse) {
            case 'current':
                datePeriodToReturn = dataStore.periodData?.current ?? defaultDatePeriod;
                break;
            case 'trading':
                datePeriodToReturn = dataStore.periodData?.trading ?? defaultDatePeriod;
                break;
            case 'latest':
                datePeriodToReturn = dataStore.periodData?.latest ?? defaultDatePeriod;
                break;
            default:
                datePeriodToReturn = defaultDatePeriod;
                break;
        }

        if (!(datePeriodToReturn.date instanceof Date)) {
            datePeriodToReturn.date = new Date(datePeriodToReturn.date);
        }

        return datePeriodToReturn;
    });
}

export function getPeriodPageOverride (
    windowType: WindowType | 'all' = 'all',
): ComputedRef<PeriodTypeOverrides> {
    const userSettings = useUserSettingsStore();

    return computed(() => {
        switch (windowType) {
            case 'boa':
                return userSettings.getBoaWindowTypeBoaDashboard();
            case 'boaComparer':
                return userSettings.getBoaWindowTypeBoaComparer();
            case 'dashboard':
                return userSettings.getBoaWindowTypeUserDashboard();
            case 'plantActivityBoard':
                return userSettings.getBoaWindowTypePlantActivity();
            default:
                return userSettings.getBoaWindowTypeAll();
        }
    });
}
